export default {
// 模块名称
  deviceAccess: {
    // 按钮类
    button: {          
      reset: '重置',
      query: '查询',
      save: '保存',
      cancel: '取消',
      confirm: '确定',
      close: '关闭',
      view: '详情',
      addsystem: '新增',
      edit: '编辑',
      uninstall: '卸载',
      back: '返回',
      sync: '同步',
      delete: '删除',
      devlist: '设备列表',
      update: '刷新列表',
      eventconf: '事件配置',
      modify: '修改',
      batchDeletion: '批量删除'
    },
    // 文字标签类
    label: {
      analyse: '视频分析平台',
      manage: '接入平台',
      accessControl: '人脸闸机',
      alarm: '报警主机',
      firefighting: '消防',
      camera: '摄像机',
      no: '序号',
      event: '原始事件/告警',
      handle: '处理方式',
      eventname: '事件名称',
      level: '告警级别',
      systemname: '系统名称',
      systemstatus: '系统状态',
      ip: 'IP',
      port: '端口',
      account: '登录账号',
      password: '登录密码',
      vcn: 'VCN',
      plugins: '插件',
      factory: '系统厂家',
      platname: '平台名称',
      version: '系统版本',
      os: '操作系统',
      protocol: '协议类型',
      connection: '连接方式',
      platform: '平台',          
      straightthrough: '直连',          
      controlcenter: '控制中心',
      domain: '域编码',
      deivcename: '设备名称',
      deviceid: '设备ID',
      deivceip: '前端设备IP',
      subdevicetype: '子设备类型',
      deivcecode: '设备编码',
      cameraname: '设备名称',
      parentcode: '父设备编码',            
      cameratype: '设备类型',
      location: '安装位置',
      network: '网络类型',
      status: '设备状态',
      volice: '启用随路音频',
      supportanalyse: '支持智能分析',
      creattime: '创建时间',
      nvr: 'NVR编码',
      exdomain: '是否为外域',
      cameradev: '设备',
      langdev: '语言设备',
      alarmdev: '告警设备',            
      maintype: '主设备类型',
      area: '所属区域',
      offline: '离线',
      online: '在线',
      sleep: '休眠',
      disabled: '停用',
      enabled: '启用',
      no2: '否',
      yes: '是',
      nosupport: '不支持',
      support: '支持',
      secretkey: '密钥',
      doorname: '门名称',
      devicemodel: '设备型号',
      doorid: '第三方设备编号',
      relaystatus: '继电器状态',
      devicetype: '设备类型',
      subSystem: '子系统',
      grade: '级别',
      alarmType: '告警类型',
    },
    // 提示类
    placeholder: {
      select: '请选择',
      deivcename: '请输入设备名称',
      deviceid: '请输入设备ID',
      doorname: '请输入门名称'
    },
    // 消息类
    message: {
      editSuccess: '修改成功',
      editFailed: '修改失败',
      nospace: '系统名称不能包含空格',
      ipformat: 'IP格式不正确',
      systemname: '请输入系统名称',
      less50: '长度在 1 到 50 个字符',
      less200: '长度在 1 到 200 个字符',
      ip: '请输入IP',
      port: '请输入端口号',
      port2: '请输入正确的端口号',
      account: '请输入登录账号',
      password: '请输入登录密码',
      vcn: '请选择VCN',
      uninstall: '您确定删除该设备吗？',
      numberchar: '只能输入数字和字母',
      onlynumber: '只能输入数字',
      plugins: '请选择插件',
      domain: '请输入域编码',
      deltips: '请选择要删除的设备',
      deltips2: '是否确认删除设备',
      delsuccess: '删除成功',
      delfail: '删除失败',
      secretkey: '请输入密钥',
      nodata: '暂无数据',
      type: '告警类型不能为空',
    },
    // 标题类
    title: {            
      warn: '提示',
      uninstall: '确认',
      devdetails: '设备详情',
      devdelete: '设备删除'
    }
  }
}
